export default "__VITE_ASSET__nCFaWuNV__"